import styled from "styled-components";
import {ContentEditable} from '@lexical/react/LexicalContentEditable';

export const Label = styled.p`
  padding: 0;
  margin: 0;
  font-size: 0.9rem;
  font-family: Montserrat;
  font-weight: 500;
  margin-bottom: 0.2rem;
`;

export const InputContainer = styled.div`
  padding: 0;
  margin: 0;
  border: 0.1rem #808080 solid;
  border-radius: 0.2rem;
  overflow: hidden;
`;

export const InnerInputContainer = styled.div`
  position: relative;
`;  

export const Input = styled(ContentEditable)`
  padding: 0;
  margin: 0;
  border: 0;
  padding: 0.5rem 1rem;
  width: 100%;
  font-size: 1rem;
  font-family: Montserrat;
`;

export const EditorToolbarContainer = styled.div`
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  padding: 0.3rem 0.5rem;
  background-color: #EFEFEF;
  display: flex;
  flex-direction: row;
`;

export const EditorToolbarButton = styled.button`
  padding: 0;
  margin: 0;
  border: none;
  background-color: ${props => props.isSelected ? '#DDD' : 'transparent'};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
  font-family: Montserrat;
  font-weight: 500;
  border-radius: 0.2rem;
  width: 2rem;

  &:hover {
    background-color: #DDD;
    cursor: pointer;
  }
`;

export const EditorToolbarButtonSpacer = styled.div`
  width: 0.5rem;
`;

export const EditorPlaceholder = styled.p`
  position: absolute;
  left: 0;
  top: 0;
  color: #CCC;
  font-family: Montserrat;
  padding: 0.5rem 1rem;
`;